import { isSafeRedirectPath } from './safe-redirect-path';

/** The two candidate landing values, in precedence order — see `resolveLandingRoute`. */
export interface LandingRouteCandidates {
  /** The `?redirectURL=` value the sign-in flow was bounced with, or `null` if absent. */
  explicitRedirect: string | null;
  /** `CurrentAccountService.defaultRedirection()` — the session's role-provided value, RAW. */
  defaultRedirection: string | null;
}

/**
 * Pure precedence resolution for capability `frontend-role-ui-preferences`: a validated
 * `?redirectURL=` beats the first role with a validated `defaultRedirection`, which beats the
 * application root `/`. A candidate that fails `isSafeRedirectPath` does not abort — it falls
 * through to the next step, exactly like a candidate that was never provided.
 *
 * No Angular dependency: this is the highest-value test surface of the capability, so it stays
 * plain-function testable.
 */
export function resolveLandingRoute({
  explicitRedirect,
  defaultRedirection,
}: LandingRouteCandidates): string {
  if (isSafeRedirectPath(explicitRedirect)) return explicitRedirect;
  if (isSafeRedirectPath(defaultRedirection)) return defaultRedirection;
  return '/';
}
